__turbopack_context__.v({
  "completed": "index-module-scss-module__O2zn2G__completed",
  "first": "index-module-scss-module__O2zn2G__first",
  "flag": "index-module-scss-module__O2zn2G__flag",
  "initial": "index-module-scss-module__O2zn2G__initial",
  "line": "index-module-scss-module__O2zn2G__line",
  "nav": "index-module-scss-module__O2zn2G__nav",
  "stage": "index-module-scss-module__O2zn2G__stage",
  "submitted": "index-module-scss-module__O2zn2G__submitted",
  "text": "index-module-scss-module__O2zn2G__text",
});
